import { useTranslation } from 'react-i18next';

import { Window } from 'components/shared/window/window';
import { SignalsActive } from './active/signals-active';
import { SignalsHistory } from './history/signals-history';

export const SignalsWindow = (props) => {
  const { t } = useTranslation();

  const tabs = [
    { text: t('windows.Активные'), id: 'active' },
    { text: t('windows.История'), id: 'history' },
  ];

  const content = {
    active: SignalsActive,
    history: SignalsHistory,
  };

  return <Window tabs={tabs} content={content} width="1030px" height="700px" contentHeight="625px" {...props.data} />;
};
